var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "223px",
    height: "224px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc0000",
    d: "M 199.5,49.5 C 199.427,51.0269 200.094,52.0269 201.5,52.5C 218.863,79.6872 223.363,109.02 215,140.5C 200.803,183.69 171.303,209.524 126.5,218C 79.8187,222.405 43.652,205.238 18,166.5C 2.1145,137.146 -0.885503,106.479 9,74.5C 12.0828,66.6638 15.9161,59.3305 20.5,52.5C 21.9063,52.0269 22.573,51.0269 22.5,49.5C 48.1711,14.5121 82.8378,-0.654603 126.5,4C 157.37,9.08123 181.704,24.2479 199.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.918
    },
    fill: "#780c05",
    d: "M 22.5,49.5 C 22.573,51.0269 21.9063,52.0269 20.5,52.5C 20.427,50.9731 21.0937,49.9731 22.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.918
    },
    fill: "#780c05",
    d: "M 199.5,49.5 C 200.906,49.9731 201.573,50.9731 201.5,52.5C 200.094,52.0269 199.427,51.0269 199.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fffdfd",
    d: "M 81.5,71.5 C 101.169,71.3334 120.836,71.5 140.5,72C 147.674,71.9671 154.341,73.6338 160.5,77C 161.667,78.8333 162.833,80.6667 164,82.5C 166.865,99.1149 167.198,115.782 165,132.5C 164.596,139.221 161.429,144.055 155.5,147C 150.53,147.886 145.53,148.552 140.5,149C 120.833,149.667 101.167,149.667 81.5,149C 75.3415,148.786 69.3415,147.786 63.5,146C 59.0508,142.603 56.5508,138.103 56,132.5C 53.8209,116.11 54.1542,99.7764 57,83.5C 58.7786,79.3882 61.6119,76.2215 65.5,74C 70.988,73.2259 76.3213,72.3925 81.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff4241",
    d: "M 101.5,95.5 C 100.167,105.5 100.167,115.5 101.5,125.5C 101.44,126.043 101.107,126.376 100.5,126.5C 99.1667,115.833 99.1667,105.167 100.5,94.5C 101.107,94.6236 101.44,94.9569 101.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ff0b06",
    d: "M 101.5,95.5 C 110.466,99.9829 119.133,104.983 127.5,110.5C 119.133,116.017 110.466,121.017 101.5,125.5C 100.167,115.5 100.167,105.5 101.5,95.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.48b906d3d517b72b3dea374349fdcdca.svg";
export { ForwardRef as ReactComponent };